export default function PageHeader({ title, subtitle, actions, backLabel, onBack }) {
  return (
    <div style={{
      background: '#fff',
      borderBottom: '1px solid #E5E7EB',
      padding: '18px 24px 14px',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: 16,
      flexShrink: 0,
    }}>
      <div>
        {onBack && (
          <button
            onClick={onBack}
            style={{
              fontSize: 11, color: '#6B7280', background: 'none',
              border: '1px solid #E5E7EB', borderRadius: 6,
              padding: '3px 10px', cursor: 'pointer', fontFamily: 'inherit',
              marginBottom: 8, display: 'inline-flex', alignItems: 'center', gap: 4,
              transition: 'all .12s',
            }}
            onMouseEnter={e => e.currentTarget.style.borderColor = '#D1D5DB'}
            onMouseLeave={e => e.currentTarget.style.borderColor = '#E5E7EB'}
          >
            ← {backLabel || 'Back'}
          </button>
        )}
        <h1 style={{
          fontSize: 20, fontWeight: 800, color: '#0F1017',
          letterSpacing: '-0.02em', lineHeight: 1.2,
          marginBottom: subtitle ? 3 : 0,
        }}>
          {title}
        </h1>
        {subtitle && (
          <p style={{ fontSize: 11.5, color: '#6B7280', marginTop: 3, lineHeight: 1.4 }}>
            {subtitle}
          </p>
        )}
      </div>
      {actions && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
          {actions}
        </div>
      )}
    </div>
  )
}
